<template>
	<div class="iconUrl">
		<div v-if="scope.status" class="data_content">
			<i class="icon el-icon-success" />
			<div class="content">
				<span>已设置站内图标：</span>
				<el-image :src="data">
					<div slot="error" class="image-slot">
						<i class="el-icon-picture-outline"></i>
					</div>
				</el-image>
			</div>
		</div>
		<div v-else class="data_content">
			<i class="icon el-icon-error" />
			<div class="content_err">{{ scope.err }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'iconUrl',
	props: ['data', 'scope'],
};
</script>

<style lang="scss" scoped>
.iconUrl {
	.data_content {
		display: flex;
		align-items: center;
		padding: 50px 20px 50px 30px;

		.icon {
			font-size: 18px;
		}

		.el-icon-success {
			color: #2abd2c;
		}

		.el-icon-error {
			color: #ff0b0b;
		}

		.content,
		.content_err {
			margin-left: 10px;
			white-space: pre-line;
		}

		.content {
			display: flex;
			align-items: center;

			span {
				margin-right: 5px;
			}
		}

		.content_err {
			color: #ff0b0b;
		}
	}
}
</style>
